import React, { Component } from 'react'
import { Pie, defaults } from 'react-chartjs-2'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { clearMetricsFilter, setMetricsFilter } from '../../actions/metrics'
import { interpolateColors } from './color-generator'
import converter from './helpers'
import NoData from './noData'

class TxByCountry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartData: {},
      color: null,
    }
    console.log(defaults.global.legend.onClick)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { props } = this
    if (prevProps.data !== this.props.data) {
      if (props.data && props.data.transaction_data) {
        const { data } = props
        if (data.transaction_data) {
          const { dataset, labels } = converter(data.transaction_data.by_country)
          const colors = interpolateColors(dataset.length)
          colors.reverse()

          const chartData = {
            labels,
            datasets: [
              {
                data: dataset,
                backgroundColor: labels.length === 1 && this.state.color ? [this.state.color] : colors,
              },
            ],
          }
          if (dataset.length === 0) {
            this.setState({ noData: true })
          } else {
            this.setState({ noData: false })
            this.setState({ chartData })
          }
        }
      }
    }
  }

  getElementsAtEvent = (elems) => {
    if (elems && elems.length) {
      const country = elems[0]._model.label
      if (this.props.filter.country === country) {
        this.setState({ color: null })
        this.props.clearMetricsFilter()
      } else if (country !== 'Other') {
        this.setState({ color: elems[0]._options.backgroundColor })
        this.props.setMetricsFilter({ country })
      }
    }
  }

  render() {
    return (
      <div className='ibox float-e-margins animated fadeIn'>
        <div className='ibox-title'>
          <h5>
            Transactions By Country For&nbsp;
            {this.props.timeSpan}
          </h5>
        </div>
        {this.state.noData && <NoData />}
        {!this.state.noData && (
          <div className='ibox-content' style={{ height: 350 }}>
            <Pie
              getElementsAtEvent={this.getElementsAtEvent}
              data={this.state.chartData}
              options={{
                maintainAspectRatio: false,
                legend: {
                  onClick(e, legendItem) {
                    if (this.legendItems.length > 1) {
                      const defaultLegendClickHandler = defaults.pie.legend.onClick.bind(this)
                      defaultLegendClickHandler(e, legendItem)
                    }
                  },
                },
              }}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.allMetrics.isFetching,
  errorMessage: state.allMetrics.errorMessage,
  filter: state.metricsFilter.filter,
  data: state.allMetrics.results,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setMetricsFilter,
      clearMetricsFilter,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxByCountry))
